export const isFullStatic = false
export const staticPath = "/builds/oabat/oabat_main/resources/nuxt/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"